export default ($resource) => {
  'ngInject';

  return $resource('/api/v1/fo/accounts/:path', {}, {
    find: {
      method: "GET",
      isArray: false
    },
    confirmRegistration: {
      method: "PUT",
      isArray: false,
      params: {path: "confirm-registration"}
    },
  });
};
